<template>
  <div class="box-alert p-3">
    <div class="dropdrown shadow" :class="large ? 'size-large' : ''">
    <Loading v-show="loading" />
      <div class="row p-4">
        <div v-if="!not_header" class="col-12 mb-2 d-flex justify-content-between">
          <h5 class="" role="alert">
            {{ title }}
          </h5>
          <button @click.prevent="$emit('close')" class="btn">
            <i class="icon icon-close"></i>
          </button>
        </div>
        <div class="col-12">
          <slot></slot>
        </div>
        <div class="col-12 mt-3">
            <slot name="footer"></slot>
        </div>
        <!-- <div class="col-12 mt-1 d-flex justify-content-between">
          <button
   
            typeClass="danger"
            @clic.prevent=""
            class="col-12 mt-1"
          >
            Excluir
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '../utils/AnimateLoad.vue'
 
export default {
  name: "DialogBox",
  props: { title: String, large: Boolean, not_header: Boolean, loading:
    {
      type: Boolean,
      default: false
    }
  },
  components: {Loading},
  methods: {
    // ...mapActions("drive", ["deleteFile"]),
    // ...mapActions("alertes", ["alertSuccess", "alertDanger"]),
    // async removeFile() {
    //   this.$emit("close-modal");
    //   await this.deleteFile(this.file.id).then(
    //     res => this.alertSuccess(`Arquivo deletado com sucesso`)
    //   )
    //   .catch(
    //     error => this.alertDanger(`Erro. \n ${error}`)
    //   )
    // },
  },
};
</script>
<style lang="scss" scoped>
.box-alert {
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
}
.dropdrown {
  position: relative;
  margin-top: 35px;
  width: 450px;
  //   right: 1rem;
  z-index: 999;
  border-radius: 0.5rem;
  font-size: 18px;
  background-color: #ffffff;
  color: #444;
  .icon {
    height: 22px;
    width: 22px;
  }
}

.size-large{
  width: 650px;
}
</style>
